import { useEffect } from 'react';
import { useMapContext } from '../contexts/mapContext';

export default function useWidgetConfigurationHandler({ widgetConfiguration }) {
	const { setIsClustered } = useMapContext()[1];

	useEffect(() => {
		const isClustered = widgetConfiguration.isClustered;
		setIsClustered(isClustered);
	}, [widgetConfiguration, setIsClustered]);
}
